import React from "react";

export type SettingsState = {
  installedPWA: boolean;
  lastInstallPrompt: number; // timestamp of when it was last shown
};

type SettingsAction =
  | { type: "SET_INSTALLED_PWA" }
  | { type: "SET_LAST_INSTALL_PROMPT"; timestamp: number }
  | { type: "SET_DATA"; data: SettingsState };

export const initialSettingsState: SettingsState = {
  installedPWA: false,
  lastInstallPrompt: -1,
};

type SettingsContext = {
  settings: SettingsState;
  dispatchSettings: React.Dispatch<SettingsAction>;
};

const SettingsContext = React.createContext<SettingsContext>({
  settings: initialSettingsState,
  dispatchSettings: () => {},
});

export default SettingsContext;

// Settings Reducer
export function settingsReducer(state: SettingsState, action: SettingsAction) {
  switch (action.type) {
    case "SET_INSTALLED_PWA": {
      console.log("SET_INSTALLED_PWA");
      return {
        ...state,
        installedPWA: true,
      };
    }
    case "SET_LAST_INSTALL_PROMPT": {
      console.log("SET_LAST_INSTALL_PROMPT", action.timestamp);
      return {
        ...state,
        lastInstallPrompt: action.timestamp,
      };
    }
    case "SET_DATA": {
      console.log("SET_DATA", action.data);
      return {
        ...action.data,
      };
    }
    default:
      return state;
  }
}
